import { ChangeEvent, FormEvent, PropsWithChildren } from 'react'
import { Trans } from 'react-i18next'

import { t } from 'i18next'
import { Styles as S } from '~/pages/email/lib/components/Form/styles'
import { Input } from '~/shared/components/Input'

interface Props {
  inputValue: string
  isButtonDisabled: boolean
  isValidInputValue: boolean
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void
  handleChange: ({ target }: ChangeEvent<HTMLInputElement>) => void
}

const Form = (props: PropsWithChildren<Props>) => {
  return (
    <S.StyledForm onSubmit={props.handleSubmit}>
      <S.Title>
        <Trans i18nKey="email.title" />
      </S.Title>

      <S.Subtitle>
        <Trans i18nKey="email.subtitle" />
      </S.Subtitle>

      <S.InputWrapper>
        <Input
          value={props.inputValue}
          isValid={props.isValidInputValue}
          placeholder={t`email.placeholder`}
          validationText={t`email.error`}
          autoComplete="off"
          inputHeight={64}
          onChange={props.handleChange}
          required
        />

        {props.children}
      </S.InputWrapper>

      <S.StyledButton type="submit" disabled={props.isButtonDisabled}>
        <Trans i18nKey="actions.continue" />
      </S.StyledButton>
    </S.StyledForm>
  )
}

export default Form
